<template>
  <div class="medicalCenter">
    <div class="topBar">
      <span class="btn-add" @click="clickAddButton">+新增</span>
      <span v-if="!refreshing" class="btn-add" @click="clickBatchRefresh"
        >批量刷新</span
      >
      <span v-else class="btn-add refreshing">{{ count }}S</span>
    </div>
    <div class="base-table">
      <div class="base-table-table">
        <el-table
          v-loading="loading"
          :data="tableList"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="65" align="center">
          </el-table-column>
          <el-table-column
            prop="externalId"
            label="直播ID"
            align="center"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="直播时间"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>
                {{ scope.row.contentLive.startTime }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="contentName"
            width="210"
            label="标题"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="publisher"
            width="130"
            label="主讲人"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="liveUrl"
            align="center"
            width="100"
            label="直播链接"
          >
            <template slot-scope="scope">
              <span class="livelink" @click="openLink(scope.row.liveUrl)">
                直播链接
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" min-width="100" label="直播状态">
            <template slot-scope="scope">
              <div
                v-html="formatStatus(scope.row.contentLive.liveStatus)"
              ></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="liveMark"
            align="center"
            width="100"
            label="直播形式"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.liveMark === 1">正式</span>
              <span v-else>测试</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="readerCount"
            width="130"
            align="center"
            label="累计观看人数"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.contentStatistics.readerCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="subscribeCount"
            align="center"
            width="100"
            label="预约人数"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.contentStatistics.subscribeCount || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createUser"
            label="创作者"
            min-width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创作时间"
            width="120"
            align="center"
          >
          </el-table-column>
          <el-table-column width="230" align="center" label="操作">
            <template slot-scope="scope">
              <div class="fr">
                <span
                  v-if="scope.row.isTop"
                  class="livelink"
                  @click="cancelTop(scope.row)"
                >
                  取消置顶
                </span>
                <span v-else class="livelink" @click="setTop(scope.row)">
                  置顶
                </span>
                <span class="border" />
                <span class="livelink" @click="editLive(scope.row)">
                  编辑
                </span>
                <span class="border" />
                <span class="livelink" @click="delLive(scope.row.contentId)">
                  删除
                </span>
                <span class="border" />
                <span
                  class="livelink"
                  :class="{ disclick: refreshing }"
                  @click="refreshLive(scope.row)"
                >
                  刷新
                </span>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty">
              <img src="@/assets/empty.png" alt="" />
              <div class="emptyText">暂无数据～</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <create-modal
      @updateLive="updateRow"
      @updateTableList="updateTableList"
      :functionsId="{
        createLive: 'health_cmp_biz_saveLive',
        updateLive: 'health_cmp_biz_updateLive',
      }"
      ref="createRef"
    />
    <del-modal
      :functionsId="{ delLive: 'health_cmp_biz_deleteLive' }"
      :contentId="delCcontentId"
      ref="delRef"
      @updateRow="updateRow"
    />
    <refresh-modal @handleRefresh="refreshLive" ref="refreshRef" />
    <live-link :mUrl.sync="url" ref="liveLinkRef" />
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import delModal from "./delModal";
import liveLink from "./liveLink";
import createModal from "./createLiveModal";
import refreshModal from "./refreshModal";
import { request } from "@/utils/axios";

export default {
  name: "liveTable",
  props: ["searchList"],
  data() {
    return {
      loading: false,
      topLoading: false,
      refreshLoading: false,
      tableList: [], // 列表数据
      url: "", // 直播链接
      count: 60, // 倒计时
      refreshing: false, // 是否正在刷新
      paginationDataProduct: {
        //分页
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      delCcontentId: "",
    };
  },
  created() {
    this.queryList();
    this.queryFlushDisableTime();
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    formatStatus(status) {
      // 直播状态格式化
      switch (status) {
        case 1:
          return '<span class="status living"></span><span class="statusText">直播中</span>';
        case 2:
          return '<span class="status end"></span><span class="statusText">已结束</span>';
        case 3:
          return '<span class="status replay"></span><span class="statusText">回放中</span>';
        case 0:
          return '<span class="status"></span><span class="statusText">预告</span>';
        default:
          return '<span class="statusText">未命名状态</span>';
      }
    },
    clickAddButton() {
      // 新增弹窗
      this.$refs.createRef.createDialog = true;
    },
    clickBatchRefresh() {
      // 批量刷新
      this.$refs.refreshRef.refreshDialog = true;
      this.$nextTick(() => {
        // 全部选中
        this.$refs.refreshRef.toggleAllSelection();
      });
    },
    handleSelectionChange(val) {
      //列表多选
      this.$refs.refreshRef.dataList = val;
    },
    paginationChangeProduct(val) {
      // 分页
      this.paginationDataProduct = val;
      this.queryList();
    },
    openLink(url) {
      // 打开直播链接
      this.url = url;
      this.$refs.liveLinkRef.linkDialog = true;
    },
    countDown() {
      // 倒计时
      this.timer = setInterval(() => {
        if (this.count <= 60 && this.count > 0) {
          this.count--;
        } else {
          this.refreshing = false;
          this.count = 60;
          this.timer && clearInterval(this.timer);
        }
      }, 1000);
    },
    refreshLive(row) {
      // 刷新直播信息
      if (this.refreshing || this.refreshLoading) return;
      this.refreshLoading = true;
      const contentIds = row?.contentId
        ? [row.contentId]
        : this.$refs.refreshRef.selectionList;
      request("health_cmp_biz_flushLive", {
        tenantId: this.$commonJs.getTenantId(),
        contentIds,
      })
        .then((res) => {
          this.refreshing = true;
          if (res && res.length) {
            this.tableList.forEach((item) => {
              res.forEach((ele) => {
                if (item.contentId === ele.contentId) {
                  item = {
                    ...item,
                    ...ele,
                  };
                }
              });
            });
          }
          this.countDown();
        })
        .catch((err) => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.refreshLoading = false;
        });
    },
    formatParams() {
      const { pageSize, currentPage: pageNo } = this.paginationDataProduct;
      const { liveTime, ...searchParams } = this.searchList;
      const liveStartTimeGte = liveTime?.length ? liveTime[0] : "";
      const liveStartTimeLte = liveTime?.length ? liveTime[1] : "";
      return {
        ...searchParams,
        pageSize,
        pageNo,
        liveStartTimeGte,
        liveStartTimeLte,
      };
    },
    queryList() {
      //获取直播列表数据
      if (this.loading) return;
      this.loading = true;
      request("health_cmp_biz_pageLive", {
        tenantId: this.$commonJs.getTenantId(),
        contentType: 12,
        ...this.formatParams(),
      })
        .then((res) => {
          this.tableList = res.data;
          this.paginationDataProduct.total = res.totalCount;
        })
        .catch((err) => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setTop(row) {
      // 置顶
      if (this.topLoading) return;
      this.topLoading = true;
      this.$confirm("确定要置顶吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request("health_cmp_biz_topLive", {
          tenantId: this.$commonJs.getTenantId(),
          contentId: row.contentId,
        })
          .then((res) => {
            if (res) {
              this.updateTableList();
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.topLoading = false;
          });
      });
    },
    cancelTop(row) {
      // 取消置顶
      if (this.topLoading) return;
      this.topLoading = true;
      this.$confirm("确定要取消置顶吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request("health_cmp_biz_cancelTopLive", {
          tenantId: this.$commonJs.getTenantId(),
          contentId: row.contentId,
        })
          .then((res) => {
            if (res) {
              this.updateTableList();
            }
          })
          .catch((err) => {
            this.$message.error(err.msg);
          })
          .finally(() => {
            this.topLoading = false;
          });
      });
    },
    delLive(contentId) {
      this.delCcontentId = contentId;
      this.$refs.delRef.delDialog = true;
    },
    editLive(row) {
      this.clickAddButton();
      this.$refs.createRef.getRow(row);
    },
    updateRow() {
      this.queryList();
    },
    updateTableList() {
      this.paginationDataProduct.currentPage = 1;
      this.queryList();
    },
    queryFlushDisableTime() {
      request("health_cmp_biz_queryFlushDisableTime", {
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          if (res && +res > 0) {
            this.refreshing = true;
            this.count = res;
            this.countDown();
          }
        })
        .catch((err) => {
          err?.msg && this.$message.error(err.msg);
        });
    },
  },
  components: {
    pagination,
    delModal,
    liveLink,
    createModal,
    refreshModal,
  },
};
</script>

<style lang="scss" scoped>
.medicalCenter {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  padding: 20px 0 36px 0;
  .topBar {
    display: flex;
    align-items: center;
    margin-left: 20px;
    span {
      cursor: pointer;
      margin-right: 12px;
    }
    .refreshing {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
  .pagination-fronted {
    padding-right: 20px;
  }
  .livelink {
    font-size: 12px;
    color: #266cee;
    cursor: pointer;
    &.disclick {
      color: #c3cbd6;
      cursor: not-allowed;
    }
  }
  :deep(.status) {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #ff782e;
    border-radius: 8px;
    margin-bottom: 2px;
    margin-right: 2px;
    &.end {
      background-color: #cccccc;
    }
    &.living {
      background-color: #04b799;
    }
    &.replay {
      background-color: #266cee;
    }
  }
  :deep(.statusText) {
    font-size: 12px;
    color: #5d6072;
  }

  .empty {
    width: 173px;
    margin: 66px auto;
    text-align: center;
    img {
      height: 122px;
    }
    .emptyText {
      margin-top: 29px;
      line-height: 14px;
      color: #9ca8b9;
      font-size: 12px;
    }
  }
  .fr {
    float: right;
  }
}
</style>
